import dayjs from 'dayjs';

/**
 * Normalizes dates so that times can be compared across different days.
 * It calculates the day difference between the first date and the current item date,
 * then creates a new date by adding that difference to the first date.
 * This allows times to be overlaid on the same chart for comparison.
 *
 * @param firstDate - The reference date to normalize to (YYYY-MM-DD format)
 * @param itemDate - The date of the current item (YYYY-MM-DD format)
 * @param timeDate - The date of the time entry (YYYY-MM-DD format)
 * @returns Normalized date string in YYYY-MM-DD format
 */
export const normalizeDateForTimeComparison = (
  firstDate: string,
  itemDate: string,
  timeDate: string,
): string => {
  if (timeDate === itemDate) {
    return firstDate;
  }
  const daysDiff = dayjs(timeDate).diff(dayjs(itemDate), 'day');
  return dayjs(firstDate).add(daysDiff, 'day').format('YYYY-MM-DD');
};
